import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { CONFIG } from 'src/config-global';
import { DashboardLayout } from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------

const IndexPage = lazy(() => import('src/pages/dashboard/dashboard/dashboard'));

// ----------------------------------------------------------------------

const Configurations = lazy(() => import('src/pages/dashboard/configurations/root'));
const CompanyConfiguration = lazy(() => import('src/pages/dashboard/configurations/company'));
const IndividualConfiguration = lazy(() => import('src/pages/dashboard/configurations/individual'));
const ScreeningConfiguration = lazy(() => import('src/pages/dashboard/configurations/screening'));

// ----------------------------------------------------------------------

const Management = lazy(() => import('src/pages/dashboard/management/management'));
const UserDetails = lazy(() => import('src/pages/dashboard/management/user'));

// ----------------------------------------------------------------------

const Logs = lazy(() => import('src/pages/dashboard/reportLogs/logs'));

// ----------------------------------------------------------------------

const Reports = lazy(() => import('src/pages/dashboard/reports/reports'));
const Report = lazy(() => import('src/sections/reports/components/report/Report'));

// ----------------------------------------------------------------------

const Groups = lazy(() => import('src/pages/dashboard/groups/groups'));
const GroupDetails = lazy(() => import('src/pages/dashboard/groups/group'));

// ----------------------------------------------------------------------

const layoutContent = (
  <DashboardLayout>
    <Suspense fallback={<LoadingScreen />}>
      <Outlet />
    </Suspense>
  </DashboardLayout>
);

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: CONFIG.auth.skip ? <>{layoutContent}</> : <AuthGuard>{layoutContent}</AuthGuard>,
    children: [
      { element: <IndexPage />, index: true },
      {
        path: 'reports',
        children: [
          { element: <Reports />, index: true },
          { path: 'report/:id', element: <Report /> },
        ],
      },
      {
        path: 'groups',
        children: [
          { element: <Groups />, index: true },
          { path: ':id', element: <GroupDetails /> },
        ],
      },
      { path: 'logs', element: <Logs /> },
      {
        path: 'management',
        children: [
          { element: <Management />, index: true },
          { path: 'user/:id', element: <UserDetails /> },
        ],
      },
      {
        path: 'configuration',
        children: [
          { element: <Configurations />, index: true },
          { path: 'company', element: <CompanyConfiguration /> },
          { path: 'individual', element: <IndividualConfiguration /> },
          { path: 'screening', element: <ScreeningConfiguration /> },
        ],
      },
    ],
  },
];
